<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <b-card title="Register a Company User" type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5">
                    <b-card-text>
                        <b-form @submit="onSubmit">
                            <b-form-group id="input-group-1" label="Full Name:" label-for="input-1">
                                <b-form-input id="input-1" v-model="form.fullName" placeholder="Enter full name" required>
                                </b-form-input>
                            </b-form-group>

                            <b-form-group id="input-2" label="Email Address:">
                                <b-form-input id="input-2" v-model="form.email" placeholder="Enter Email address" required>
                                </b-form-input>
                            </b-form-group>
                            <b-button type="submit" variant="primary" class="my-4">Submit</b-button>
                        </b-form>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</div>